import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from 'translations';
import ProductsSlider from 'components/products-slider';
import EmptyCategorySlider from 'components/mymigros-sliders/empty-category-slider';
import categoryIcons from 'constants/category-icons';

const PLACEHOLDER_ICON = categoryIcons.default;

/**
 * @extends React.Component<IMyMigrosSliderPlugin>
 */
export default class MyMigrosSlider extends Component {
    static propTypes = {
        hasFetchedData: PropTypes.bool,
        title_key: PropTypes.string.isRequired,
        header_link_label_key: PropTypes.string.isRequired,

        category: PropTypes.object,

        /** @type {IProduct[]} */
        products: PropTypes.array.isRequired,

        /** @type {ICategoryLink} */
        link: PropTypes.object.isRequired,
    };

    static defaultProps = {
        hasFetchedData: false,
        category: null,
    };

    render() {
        const { title_key, products, link, category, hasFetchedData, header_link_label_key } = this.props;
        const categoryIcon = category ? categoryIcons[category.id] : null;

        //const hasProducts = false;
        const hasProducts = products.length > 0;

        return (
            <div className="mymigros-slider">
                { !hasProducts &&
                <EmptyCategorySlider
                    link={ link.to }
                    link_label_key={ link.label_key }
                    header_link_label_key={ header_link_label_key }
                    title={ t(title_key) }
                    show_description={hasFetchedData}
                    icon_key={ categoryIcon || PLACEHOLDER_ICON }/> }

                { hasProducts &&
                <ProductsSlider
                    link={ link.to }
                    link_label_key={ link.label_key }
                    header_link_label_key={ header_link_label_key }
                    skipTests={ true }
                    products={ products }
                    title={ t(title_key) }
                />
                }
            </div>
        );
    }
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/mymigros-sliders/mymigros-slider/index.js